import { tv } from 'tailwind-variants';

export const styles = tv({
  base: '',
  slots: {
    navigationRoot: `
      relative
      sticky
      top-0
      z-20
      flex
      justify-center
      border-neutral-100
      bg-white
      pt-2
    `,
    navigationList: `
      flex
      list-none
      justify-center
    `,
    navigationItem: `
      -mb-[2px]
      block
      flex
      h-10
      cursor-pointer
      select-none
      items-center
      rounded-t-md
      border-b-2
      border-transparent
      bg-transparent
      px-4
      py-2
      text-lg
      text-neutral-700
      focus:shadow-[0_0_0_3px]
    `,
  },
  variants: {
    isActive: {
      true: {
        navigationItem: `
          border-primary-600
          text-neutral-900
          focus:shadow-primary-100
        `,
      },
      false: {
        navigationItem: 'focus:shadow-neutral-100',
      },
    },
    isFetching: {
      false: {
        navigationItem: 'hover:bg-neutral-100',
      },
    },
  },
});
